import FormModel from "../../models/form";

/**
 * Router session management utility
 */
class RouterSessionManagement {

    /**
     *  Obtains the form from the server based on the ID given.
     *  Invokes the remaining three parameters when those states
     *  are achieved by the Ajax controller.
     * 
     * @param {string} referenceNumber 
     * @param {function} done 
     * @param {function} fail 
     * @param {function} always 
     */
    obtainForm (referenceNumber, done, fail, always = () => {}) {
        this.form = new FormModel({ referenceNumber });
        const deferred = this.form.fetch();
        deferred.done(formDataObj => done(formDataObj));
        deferred.fail(_ => fail());
        deferred.always(_ => always(_));
    }

    async obtainConfig (organisationId) {
        const body = await fetch(`${GLOBALS.API_URL}/organisation-configuration/${organisationId}`)
        const data = await body.json();
        return data;
    }

    async obtainOrganisationConfig (organisationId) {
        const body = await fetch(`${GLOBALS.API_URL}/organisation-configuration-presets/${organisationId}`)
        const data = await body.json();
        return data;
    }

}

export default RouterSessionManagement;



// WEBPACK FOOTER //
// ./public/domain/controllers/router-session-management/index.js